import {Link as PrimerLink} from '@primer/react'
import {Link} from '@github-ui/react-core/link'
import {clsx} from 'clsx'
import styles from './SidebarListItem.module.css'

interface SidebarListItemProps {
  icon?: React.ReactNode
  label: React.ReactNode
  description?: React.ReactNode
  href: string
  onClick?: () => void
  className?: string
  /** Link target attribute (e.g. '_blank' for new tab). */
  target?: string
  /** Link rel attribute (e.g. 'noopener noreferrer'). */
  rel?: string
}

/** A sidebar list row with an optional leading icon and trailing description. */
export function SidebarListItem({
  icon,
  label,
  description,
  href,
  onClick,
  className,
  target,
  rel,
}: SidebarListItemProps) {
  return (
    <li className={clsx(styles.item, className)}>
      {icon != null && <span className={styles.icon}>{icon}</span>}
      {target ? (
        <PrimerLink href={href} target={target} rel={rel} className={styles.label} onClick={onClick}>
          {label}
        </PrimerLink>
      ) : (
        <PrimerLink as={Link} to={href} className={styles.label} onClick={onClick}>
          {label}
        </PrimerLink>
      )}
      {description != null && <span className={styles.description}>{description}</span>}
    </li>
  )
}
